/**
 * Experience Type Icon Component
 * Renders the appropriate icon based on experience type
 */

import React from 'react';
import { typographyColors } from '@/design-system/utils';
import { ExperienceCard } from '@/constants/chatScreenData';

export interface ExperienceTypeIconProps {
  type: ExperienceCard['type'];
  size?: number;
}

export const ExperienceTypeIcon: React.FC<ExperienceTypeIconProps> = ({
  type,
  size = 12,
}) => {
  const viewBox = '0 0 20 20';
  const commonProps = {
    width: size,
    height: size,
    viewBox,
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
  };

  switch (type) {
    case 'activities':
      return (
        <svg {...commonProps}>
          <path
            d='M10 2.5L12.5 7.5L10 12.5L7.5 7.5L10 2.5Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );

    case 'signature':
      return (
        <svg {...commonProps}>
          <path
            d='M10 15L3.82 18.18L5.23 11.27L0 6.91L7.09 6.18L10 0L12.91 6.18L20 6.91L14.77 11.27L16.18 18.18L10 15Z'
            stroke={typographyColors.primary}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
            fill='none'
          />
        </svg>
      );

    case 'package':
      return (
        <svg {...commonProps}>
          <path
            d='M13.3333 10.75V14.25C13.3333 15.2145 12.5478 16 11.5833 16H5.75C4.78547 16 4 15.2145 4 14.25V8.41667C4 7.45214 4.78547 6.66667 5.75 6.66667H9.25'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );

    case 'riders-corner':
      return (
        <svg {...commonProps}>
          <path
            d='M2.5 6.66667C2.5 5.74619 3.24619 5 4.16667 5H15.8333C16.7538 5 17.5 5.74619 17.5 6.66667V13.3333C17.5 14.2538 16.7538 15 15.8333 15H4.16667C3.24619 15 2.5 14.2538 2.5 13.3333V6.66667Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );

    case 'stays':
      return (
        <svg {...commonProps}>
          <path
            d='M2.5 8.33333L10 3.33333L17.5 8.33333V16.6667C17.5 17.5871 16.7538 18.3333 15.8333 18.3333H4.16667C3.24619 18.3333 2.5 17.5871 2.5 16.6667V8.33333Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.5 18.3333V10H12.5V18.3333'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );

    default:
      return null;
  }
};
